import PageHeader from "src/components/PageHeader";

export default function Reviews() {
  return (
    <PageHeader
      title="مدیریت دیدگاه‌ها"
    />
  )
}